// import topSchools1 from "../assets/img/ukTop1.png";
// import topSchools3 from "../assets/img/ukTop3.png";
// import topSchools2 from "../assets/img/ukTop2.png";


const irelandBanner = "https://career-advice.jobs.ac.uk/wp-content/uploads/Ireland-e1634207359729-1170x630.jpg.optimal.jpg"
const canadaBanner = "https://www.commonwealthfund.org/sites/default/files/styles/countries_hero_desktop/public/country_image_Canada.jpg?h=f2fcf546&itok=tfGdKLUg"
const usBanner = "https://i.natgeofe.com/k/5b396b5e-59e7-43a6-9448-708125549aa1/new-york-statue-of-liberty.jpg?w=1436&h=808"
const ukBanner = "https://career-advice.jobs.ac.uk/wp-content/uploads/london-e1634207674493-1170x630.jpg.optimal.jpg"
const austBanner = "https://ik.imagekit.io/tvlk/blog/2024/09/QAj7kSrK-shutterstock_2495680553.jpg?tr=dpr-2,w-675"
const dubaiBanner = "https://res.cloudinary.com/dtljonz0f/image/upload/c_auto,ar_4:3,w_3840,g_auto/f_auto/q_auto/shutterstock_2414539851_ss_non-editorial_dcx0bm?_a=BAVARSAP0"
const franceBanner = "https://dynamic-media.tacdn.com/media/photo-o/30/42/46/65/caption.jpg?f=webp&w=1000&h=700"
const italyBanner = "https://media.worldnomads.com/Explore/europe/5-things-italy.jpg"

export const countriesDatabase = {
  canada: {
    name: "Canada",
    description:
      "A diverse and inclusive country celebrated for its world-class education, stunning natural landscapes, and welcoming multicultural communities.",
      schDescription: "Canada boasts globally competitive universities renowned for research, innovation, and academic excellence. According to recent rankings",
    flag: "🇨🇦",
    thumbnail: canadaBanner,
    whyStudy:"Whether pursuing undergraduate or postgraduate studies, Canada stands out as an excellent destination for students looking to advance their education and career prospects.",
    topSchools: [
      "https://i.pinimg.com/736x/bc/81/05/bc8105eb5fdea7f2fd18ee88c8f0a458.jpg",
      "https://www.usnews.com/object/image/00000155-7e9e-d3ec-a9fd-7fdfc7240000/160623-ubc-submitted.jpg?update-time=1466708333713&size=responsiveFlow970",
      "https://d31cuupyjbe4e1.cloudfront.net/university/undefined/University%20of%20Alberta-1633930698881-3300f8c5-a7ca-4007-ba7c-c8d933cad216.jpg",
    ],
    overview: {
      students: "1,040,985",
      colleges: "223",
      capital: "Ottawa",
      language: "English",
      currency: "CAD",
      dailingCode: "+1",
      gdp: "$ 2.14 Trillion",
      population: "40.1 Million",
    },
    fees: {
      undergraduate: "CAD 20,000–30,000/year",
      postgraduate: "CAD 16,000–30,000/year",
      phd: "CAD 16,000–30,000/year",
      transport: "CAD 80–150/month",
      rent: "CAD 700–1,500/month",
      food: "CAD 300–600/month",
      internet: "CAD 600–900/year",
      
    },
    programs: [
        {
            id:1,
            name: "Computer Science and IT",
            description: "High demand for skills in software development, cybersecurity, and data analysis due to rapid technological advancements."
        },
        {
            id:2,
            name: "Engineering",
            description: "Specializations in civil, mechanical, and electrical engineering are sought after for Canada’s industrial and infrastructure growth."
        },
        {
            id:3,
            name: "Business and Management",
            description: "Popular for career opportunities in finance, marketing, and HR."
        },
        {
            id:4,
            name: "Healthcare and Medicine",
            description: "Growth in the healthcare sector drives demand for nursing, medicine, and public health professionals."
        },
    ],
    schools: [
        {
            id:1,
            logo: "https://www.diglib.org/wp-content/uploads/sites/3/2014/12/UofT_Logo.svg_-e1418677958967.png",
            name: "University of Toronto",
        },
        {
            id:2,
            logo: "https://brand3.sites.olt.ubc.ca/files/2018/09/5NarrowLogo_ex_768.png",
            name: "University of British Columbia (UBC)",
        },
        {
            id:3,
            logo: "https://i.namu.wiki/i/08T3OZH8vK-P3_lxqC5YRxv-xZswyOSmwNkeh7VYDdcmNKlYj3zoHmgOsu9lLdBADpAF7eg4N7BflGj-Yd7wxQ.png",
            name: "McGill University",
        },
        {
            id:4,
            logo: "https://upload.wikimedia.org/wikipedia/en/thumb/5/53/McMaster_University_logo.svg/1200px-McMaster_University_logo.svg.png",
            name: "McMaster University",
        },
        {
            id:5,
            logo: "https://al-roomi.org/LaTeX_World/Templates/Theses_Dissertations/Canada/University_of_Alberta/University_of_Alberta_Logo.png",
            name: "University of Alberta",
        },
        {
            id:6,
            logo: "https://i.pinimg.com/736x/ec/ac/d5/ecacd5cc33aaa837c8bfbc0e5f1bbf50.jpg",
            name: "University of Waterloo",
        },
        {
            id:7,
            logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/dc/Memorial_University_of_Newfoundland_Logo.svg/1200px-Memorial_University_of_Newfoundland_Logo.svg.png",
            name: "Memorial University of Newfoundland",
        },
        {
            id:8,
            logo: "https://upload.wikimedia.org/wikipedia/commons/8/87/Logo_York_University.svg",
            name: "York University",
        },
        {
            id:9,
            logo: "https://www.eduopinions.com/wp-content/uploads/2022/05/University-of-Manitoba-350x169.png",
            name: "University of Manitoba",
        },
        // {
        //     id:10,
        //     logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSvm8QoFrStlevMH_Ar_7krKm5DhYywSXRp-A&s",
        //     name: "University of Regina",
        // },
       
        
    ],
    admissions: [
        {
            id:1,
            name: "Academic Records",
            description: "High school diploma for undergraduate programs; bachelor's degree for graduate programs."
        },
        {
            id:2,
            name: "Language Proficiency",
            description: "IELTS, TOEFL, or Duolingo scores required (varies by institution)."
        },
        {
            id:3,
            name: "Letter of Recommendation",
            description: "Usually 2–3 from teachers or professionals."
        },
        {
            id:4,
            name: "Statement of Purpose (SOP",
            description: "Explains motivations and goals."
        },
        {
            id:5,
            name: "Resume/CV",
            description: "Required for graduate programs to highlight experience."
        },
        {
            id:6,
            name: "Study Permit",
            description: "Mandatory for all international students."
        },
        
    ],
    regions: [
      {
        school1: "University of Toronto",
        school2: "University of British Columbia (UBC)",
        school3: "University of Alberta",
      },
    ],
    whyStudy1: {
        title: "Post-Graduation Opportunities",
        body: "Programs like the Post-Graduation Work Permit (PGWP) make it easier for graduates to gain Canadian work experience and transition to permanent residency (Study in Canada, 2024)​"
    },
    whyStudy2: {
        title: "Globally Ranked Universities",
        body: "Canada is home to top institutions like the University of Toronto and McGill University, known for their research excellence and academic reputation (QS, 2024; Times Higher Education, 2024) ​Times Higher Education (THE) College Consensus"
    },
    whyStudy3: {
        title: "World-Class Research Opportunities",
        body: "Canadian universities excel in cutting-edge research, particularly in areas like artificial intelligence, health sciences, and climate studies (QS, 2024)​】"
    },
    whyStudy4: {
        title: "Multicultural Environment",
        body: "With a large international student community, Canada fosters cultural exchange and inclusivity, ensuring students feel at home (Amber, 2024)​"
    },
  },
  france: {
    name: "France",
    description:
      "A global leader in culture, art, and education, France offers students a world-class academic experience, a rich historical heritage, and a vibrant lifestyle.",
    schDescription: "France is renowned for its prestigious institutions, rich academic tradition, and contributions to global research. The country offers numerous world-class universities and specialized schools",
    flag: "🇫🇷",
    thumbnail: franceBanner,
    whyStudy:" Whether pursuing undergraduate or postgraduate studies, France is a prime choice for those seeking to further their academic and career ambitions.",
    topSchools: [
      "https://upload.wikimedia.org/wikipedia/commons/4/46/P1300734_Paris_V_place_de_la_Sorbonne_rwk.jpg",
      "https://image.climbfinder.com/-upload-64182-1024x0.jpeg",
      "https://smapse.com/storage/2018/12/28575627-1815698398504572-7194212321863410395-n.jpg",
    ],
    overview: {
      students: "430,466 ",
      colleges: "3,500",
      capital: "Paris",
      language: "French",
      currency: "Euro",
      dailingCode: "+33",
      gdp: "$ 3.031 trillion",
      population: "68.17 Million",
    },
    fees: {
      undergraduate: "€2,770/year",
      postgraduate: "€3,770/year",
      phd: "-",
      transport: "€30 – €75/month",
      rent: "€400 – €800/month",
      food: " €200 – €300/month",
      internet: "€20 – €50/month",
      
    },
    programs: [
        {
            id:1,
            name: "Business and Management",
            description: "Globally renowned “Grande École” programs at top institutions, offering prestigious credentials and career opportunities."
        },
        {
            id:2,
            name: "Engineering and Technology",
            description: "France’s innovation hub status makes it attractive, with top schools like École Polytechnique and Sorbonne University offering specialized programs."
        },
        {
            id:3,
            name: "Social Sciences",
            description: "Renowned programs in political science, economics, and globalization at institutions like Sciences Po Paris and Université Paris-Dauphine."
        },
        {
            id:4,
            name: "Arts and Humanities",
            description: "France’s cultural legacy draws students to fields like literature, philosophy, and political science, with programs at Paris-Sorbonne University and École Normale Supérieure (ENS)."
        },
    ],
    schools: [
        {
            id:1,
            logo: "https://i.namu.wiki/i/2e2DHVuZQRSrO6JMaPULBDUYBNIN49vbPBpTWZixAkWU4wb2zxFL2DK_skU-h_0jTUOBuvXA45gGyXFLxD2ziQ.webp",
            name: "Sorbonne University",
        },
        {
            id:2,
            logo: "https://logos-download.com/wp-content/uploads/2019/01/%C3%89cole_Polytechnique_Logo.png",
            name: "École Polytechnique",
        },
        {
            id:3,
            logo: "https://upload.wikimedia.org/wikipedia/fr/thumb/e/e7/Logo_Universit%C3%A9_de_Paris.svg/2560px-Logo_Universit%C3%A9_de_Paris.svg.png",
            name: "Université de Paris",
        },
        {
            id:4,
            logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQhaIbEZXZqOf8ti8h2BmkxHMTHGfLaqxC7kw&s",
            name: "University of Montpellier",
        },
        {
            id:5,
            logo: "https://yorkinternational.yorku.ca/files/2018/03/1280px-University_of_Strasbourg_logo.svg-1.png",
            name: "University of Strasbourg",
        },
        {
            id:6,
            logo: "https://upload.wikimedia.org/wikipedia/en/a/ae/Lyon_university_logo.png",
            name: "University of Lyon",
        },
        {
            id:7,
            logo: "https://blogs.upm.es/circulareelisa/wp-content/uploads/sites/914/2023/07/dschoollogodefinitif.png",
            name: "École des Ponts ParisTech",
        },
        {
            id:8,
            logo: "https://upload.wikimedia.org/wikipedia/commons/5/52/TSE_Logo_2019.png",
            name: "Toulouse School of Economics (TSE)",
        },
        {
            id:9,
            logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/Logo_Universit%C3%A9_Grenoble_Alpes_2020.svg/1200px-Logo_Universit%C3%A9_Grenoble_Alpes_2020.svg.png",
            name: "Grenoble Alpes University",
        },
       
        
    ],
    admissions: [
        {
            id:1,
            name: "Academic Records",
            description: "High school diploma for undergraduates; bachelor’s degree for graduate programs"
        },
        {
            id:2,
            name: "Statement of Motivation",
            description: "Explains the applicant's goals and reasons for choosing the program."
        },
        {
            id:3,
            name: "Passport Copy",
            description: "Valid for identification and visa purposes."
        },
        {
            id:4,
            name: "Language Proficiency",
            description: "•	For English-taught programs: IELTS or TOEFL. •	For French-taught programs: TCF, DELF, or DALF."
        },
        {
            id:5,
            name: "ID Photos",
            description: "Recent passport-sized photographs required."
        },
        {
            id:6,
            name: "Proof of Financial Resources",
            description: "Evidence of ability to cover tuition and living costs."
        },
        {
            id:7,
            name: "Health Insurance",
            description: "Proof of coverage during the stay."
        },
    ],
    regions: [
      {
        school1: "Sorbonne University",
        school2: "École Polytechnique",
        school3: "Université de Paris",
      },
    ],
    whyStudy1: {
        title: "Post-Graduation Opportunities",
        body: "France allows international students to stay and work after graduation, providing ample career opportunities in various sectors.Sources: EduRank, QS Rankings​"
    },
    whyStudy2: {
        title: "Globally Recognized Institutions",
        body: "France is home to some of the world’s most prestigious universities and business schools, offering degrees that are highly valued by employers worldwide.​"
    },
    whyStudy3: {
        title: "Research and Innovation Hub",
        body: "France is a leader in scientific research and innovation, offering students opportunities to engage in groundbreaking projects. Sources: Times Higher Education, Study in Europe"
    },
    whyStudy4: {
        title: "Rich Cultural Heritage",
        body: "Studying in France offers students a chance to experience French culture, history, and cuisine, making it a unique educational experience."
    },
  },
  
  usa: {
    name: "The United States",
    description:
      "A dynamic and innovative country offering unparalleled educational opportunities, cutting-edge research, and a culturally diverse environment.",
    schDescription: "The United States is a premier destination for higher education, offering a diverse range of institutions and opportunities tailored to various academic goals and financial capacities. Here is a professional breakdown of three key areas for prospective international students: highest-rated universities, most demanded institutions, and best budget options.",
    flag: "🇺🇸",
    thumbnail: usBanner,
    whyStudy:"With world-renowned universities and diverse opportunities, the United States is a top choice for students aiming to elevate their academic and professional goals.",
    topSchools: [
      "https://images.squarespace-cdn.com/content/v1/607b0a89e200d928578629e7/ffeeb429-704f-4cad-983a-c9f5e9c1c1e3/Princeton1.jpg",
      "https://media.tacdn.com/media/attractions-splice-spp-674x446/0b/27/a8/8d.jpg",
      "https://vnis.edu.vn/wp-content/uploads/2023/09/Harvard-University-1-1.webp",
    ],
    overview: {
      students: "1,057,188",
      colleges: "3,982",
      capital: "Washington, D.C.",
      language: "English",
      currency: "USD",
      dailingCode: "+1",
      gdp: "$ 27.36 trillion",
      population: "334.9 Million",
    },
    fees: {
      undergraduate: "$20,000–$35,000/year",
      postgraduate: "$20,000–$35,000/year",
      phd: "-",
      transport: "$50–$100/month.",
      rent: "$500–$1,200/month",
      food: "$300–$500/month",
      internet: "$500–$1,500/year",
      
    },
    programs: [
        {
            id:1,
            name: "Artificial Intelligence (AI) and Computer Science",
            description: "AI-focused programs are growing as industries integrate AI technologies. Universities like Emory University and the University of Florida offer AI minors and certificates."
        },
        {
            id:2,
            name: "Business and Finance",
            description: "Popular for their versatility, these programs lead to diverse career paths in the corporate world. Baruch College is renowned for its business and finance offerings."
        },
        {
            id:3,
            name: "Nursing and Healthcare",
            description: "With healthcare’s continuous growth, nursing and healthcare programs remain in demand. Angelo State University offers specialized nursing courses."
        },
        {
            id:4,
            name: "Environmental Studies",
            description: "Programs focusing on sustainability and ecological issues are growing, with schools like SUNY Binghamton offering comprehensive environmental studies courses."
        },
    ],
    schools: [
        {
            id:1,
            logo: "https://miro.medium.com/v2/resize:fit:1400/1*RoxMLLYuDdYmFCKtOAUdwQ.png",
            name: "Princeton University",
        },
        {
            id:2,
            logo: "https://logos-world.net/wp-content/uploads/2021/09/MIT-Massachusetts-Institute-of-Technology-Logo.png",
            name: "Massachusetts Institute of Technology (MIT)",
        },
        {
            id:3,
            logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/70/Harvard_University_logo.svg/2560px-Harvard_University_logo.svg.png",
            name: "Harvard University",
        },
        {
            id:4,
            logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR9B0bat6qwQYivFlyOFFR3B4uqFhqd0wISfg&s",
            name: "Stanford University",
        },
        {
            id:5,
            logo: "https://logos-world.net/wp-content/uploads/2022/02/UC-Berkeley-Symbol.png",
            name: "University of California, Berkeley",
        },
        {
            id:6,
            logo: "https://www.vhv.rs/file/max/27/278498_ucla-logo-png.gif",
            name: "University of California, Los Angeles (UCLA)",
        },
        {
            id:7,
            logo: "https://kycompact.org/wp-content/uploads/sites/53/2017/09/berea-college-logo-1024x984.png",
            name: "Berea College (Kentucky)",
        },
        {
            id:8,
            logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSHGPodz7sxsDiDzrsxKl5TXj0QitIgIB3yZQ&s",
            name: "Arizona State University (ASU)",
        },
        {
            id:9,
            logo: "https://images.crunchbase.com/image/upload/c_pad,f_auto,q_auto:eco,dpr_1/v1417945972/ouglzokcgjmksz4z9grz.png",
            name: "University of North Carolina, Chapel Hill (UNC)",
        },
       
        
    ],
    admissions: [
        {
            id:1,
            name: "Academic Records",
            description: "Submission of transcripts that show strong academic performance in the relevant field."
        },
        {
            id:2,
            name: "Standardized Test Scores",
            description: "SAT/ACT for undergraduate admission and GRE/GMAT for graduate programs (some schools may be test-optional)."
        },
        {
            id:3,
            name: "Letters of Recommendation",
            description: "2–3 letters from teachers or professionals who can vouch for the applicant's qualifications."
        },
        {
            id:4,
            name: "Personal Statement/Statement of Purpose",
            description: "A written essay explaining motivations and reasons for choosing the program."
        },
        {
            id:5,
            name: "English Language Proficiency",
            description: "TOEFL or IELTS scores for non-native English speakers (requirements vary)."
        },
        {
            id:6,
            name: "Financial Documentation",
            description: "Proof of sufficient funds to cover tuition and living costs."
        },
        
    ],
    regions: [
      {
        school1: "Princeton University",
        school2: "Massachusetts Institute of Technology (MIT)",
        school3: "Harvard University",
      },
    ],
    whyStudy1: {
        title: "Top Global Rankings",
        body: "Institutions like MIT, Stanford, and Harvard are world leaders in innovation, research, and teaching excellence (Times Higher Education, 2024)​"
    },
    whyStudy2: {
        title: "Diverse Academic Programs",
        body: "The U.S. offers unparalleled academic variety, from liberal arts colleges to specialized institutions, catering to nearly every field of study (U.S. News & World Report, 2024)​"
    },
    whyStudy3: {
        title: "Research and Innovation",
        body: "U.S. universities lead globally in research funding and facilities, offering students opportunities to work on groundbreaking projects (QS, 2024)​"
    },
    whyStudy4: {
        title: "Cultural Diversity and Student Life",
        body: "The U.S. is a melting pot of cultures, offering an enriching experience both academically and socially (Amber, 2024)​"
    },
  },
  uk: {
    name: "The United Kingdom",
    description:
      "A historic and globally respected destination for education, blending tradition with innovation in a multicultural setting.",
    schDescription: "The United Kingdom boasts some of the most prestigious universities globally, excelling in both academic reputation and research impact. Among the highest-rated institutions",
    flag: "🇬🇧",
    thumbnail: ukBanner,
    whyStudy:"The United Kingdom, known for its prestigious institutions and rich academic heritage, is an ideal destination for students pursuing higher education and career advancement.",
    topSchools: [
      "https://c.files.bbci.co.uk/2c03/live/64d39070-8596-11ef-addc-5556603eb4c1.jpg",
      "https://media.wired.com/photos/660325aa2f517f41a849f677/16:9/w_2400,h_1350,c_limit/University-of-Cambridge-Hack-Security-GettyImages-1251809815.jpg",
      "https://student.studios2let.com/wp-content/uploads/2021/09/imperial-college-london-student-accommodation-nearby.jpg.webp",
    ],
    overview: {
      students: "758,855,",
      colleges: "262",
      capital: "London",
      language: "English",
      currency: "GPB",
      dailingCode: "+44",
      gdp: "$ 3.34 trillion",
      population: "68.35 Million",
    },
    fees: {
      undergraduate: "£10,000 -£38,000",
      postgraduate: "Fees varies",
      phd: "Fees varies",
      transport: "£40 -£100",
      rent: "Averages £418/month ",
      food: "£120 -£200",
      internet: "£30 -£50",
      
    },
    programs: [
        {
            id:1,
            name: "Medicine & Dentistry",
            description: "These fields have a 99.4% employment rate within six months of graduation."
        },
        {
            id:2,
            name: "Veterinary Science",
            description: "Graduates from this field have a 95.9% employment rate soon after finishing their studies."
        },
        {
            id:3,
            name: "Allied Medicine",
            description: "Programs such as physiotherapy and radiography are in high demand due to the growing healthcare sector."
        },
        {
            id:4,
            name: "Education Studies",
            description: "With a constant need for educators, this field offers strong job prospects."
        },
        {
            id:5,
            name: "Engineering",
            description: "Civil, mechanical, and electrical engineering specializations are highly valued in the job market."
        },
        {
            id:6,
            name: "Computer Science",
            description: "As technology advances, expertise in AI and cybersecurity is increasingly in demand."
        },
    ],
    schools: [
        {
            id:1,
            logo: "https://upload.wikimedia.org/wikipedia/commons/2/2f/University_of_Oxford.svg",
            name: "University of Oxford",
        },
        {
            id:2,
            logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcScWiuFA5q-cn34u2Vyahe6sUPIm-UiG_Hbng&s",
            name: "University of Cambridge",
        },
        {
            id:3,
            logo: "https://banner2.cleanpng.com/20180415/ivw/avfqfm9mk.webp",
            name: "Imperial College London",
        },
        {
            id:4,
            logo: "https://i.namu.wiki/i/7P2YRAHZKBusEZxNz_BD3Ad3Wwxiqo2npuNumvCZZ-Ogw1kg6yzO6Cuh_537enGDp-M683cNQ7wKYSn4s2tenA.webp",
            name: "University College London (UCL)",
        },
        {
            id:5,
            logo: "https://logos-download.com/wp-content/uploads/2022/10/University_of_Manchester_Logo.png",
            name: "University of Manchester",
        },
        {
            id:6,
            logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTt29bQHvuaNdqj8ubDWlQJaXj0NDbZGmWD4Q&s",
            name: "King’s College London",
        },
        {
            id:7,
            logo: "https://storage-prtl-co.imgix.net/endor/organisations/217/logos/1724312092_uclan_primary_logo_digital-1.png",
            name: "University of Central Lancashire",
        },
        {
            id:8,
            logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSYfMAsT4FYKuopH82uQX871s9d0Lx6DGyaHg&s",
            name: "Edinburgh Napier University",
        },
        {
            id:9,
            logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRJ_GxKExJ5Ii3dXCiIATWLDGlzlh5TEb0BIQ&s",
            name: "De Montfort University (Leicester)",
        },
       
        
    ],
    admissions: [
        {
            id:1,
            name: "Undergraduate Programs",
            description: "Completion of secondary education equivalent to UK A-levels. For example, qualifications like the International Baccalaureate (IB) or Advanced Placement (AP) courses are acceptable."
        },
        {
            id:2,
            name: "Postgraduate Programs",
            description: " A relevant undergraduate degree with a strong academic record is needed. For instance, the University of Manchester typically requires a minimum GPA of 3.0 (preferably 3.3+)."
        },
        {
            id:3,
            name: "English Language Proficiency",
            description: "Non-native English speakers need an IELTS score of at least 6.0 (some programs may require higher scores)."
        },
        {
            id:4,
            name: "Additional Documents:",
            description: "•	Personal Statement explaining motivations and goals. •	Letters of Recommendation from teachers or professionals. •	Portfolio for courses like design or architecture. •	Some programs may require entrance exams or interviews."
        },
        // {
        //     id:5,
        //     name: "English Proficiency Tests",
        //     description: "Most UK universities require proof of English language proficiency for non-native speakers. The IELTS (International English Language Testing System) is widely accepted, typically requiring a score of 6.0-7.5."
        // },
        // {
        //     id:6,
        //     name: "Curriculum Vitae (if applicable)",
        //     description: "A CV may be required for certain programs or for applicants with significant work experience. It should outline your academic history, work experience, skills, and extracurricular achievements."
        // },
        // {
        //     id:7,
        //     name: "GMAT/GRE Scores",
        //     description: "Certain postgraduate courses, particularly in fields like Business (MBA programs) or Finance, may require standardized test scores such as the GMAT (Graduate Management Admission Test) or GRE (Graduate Record Examinations)."
        // },
        // {
        //     id:8,
        //     name: "Portfolio (for Creative Programs)",
        //     description: "Applicants to courses like Architecture, Design, or Fine Arts are often required to submit a portfolio showcasing their previous work. This helps universities evaluate your creativity and technical skills."
        // },
        
    ],
    regions: [
      {
        school1: "University of Oxford",
        school2: "University of Cambridge",
        school3: "Imperial College London",
      },
    ],
    whyStudy1: {
        title: "Strong Employability",
        body: "UK graduates are highly valued globally, supported by university-industry partnerships and extensive alumni networks (QS, 2024; Amber, 2024)​"
    },
    whyStudy2: {
        title: "Prestigious Universities",
        body: "Institutions such as Oxford, Cambridge, and Imperial College London consistently rank among the top in the world for academic excellence and research impact (Times Higher Education, 2024; QS, 2024)​"
    },
    whyStudy3: {
        title: "Generous Scholarships",
        body: "Scholarships such as Chevening and Commonwealth are widely available, reducing financial barriers for international students (Study UK, 2024)​"
    },
    whyStudy4: {
        title: "Rich Cultural and Historical Exposure",
        body: "Studying in the UK offers students the chance to immerse themselves in a culturally vibrant and historically rich environment (Education Rankings, 2024)​"
    },
  },
  australia: {
    name: "Australia",
    description:
      "A sunny and progressive country recognized for its high-quality education, relaxed lifestyle, and diverse cultural experiences.",
    schDescription: "Australia hosts some of the world's best universities, consistently appearing in global rankings such as QS World University Rankings and Times Higher Education (THE). Notable mentions include:",
    flag: "🇦🇺",
    thumbnail: austBanner,
    whyStudy:"Whether for undergraduate or postgraduate studies, Australia offers high-quality education and global career opportunities, making it a preferred choice for ambitious students.",
    topSchools: [
        "https://www.sydney.edu.au/content/dam/corporate/images/sydney-environment-institute/articles/august-2022/call-for-submissions/quad.jpg",
      "https://edysor.in/images/university/banner/University-of-Melbourne.webp",
      "https://www.ncuk.ac.uk/wp-content/uploads/2020/11/University-of-New-South-Wales-UNSW-Sydney-Image-Gallery-3.jpg",
    ],
    overview: {
      students: "824,951",
      colleges: "42",
      capital: "Canberra",
      language: "English",
      currency: "AUD",
      dailingCode: "+61",
      gdp: "$ 1.724 Trillion",
      population: "26.64 Million",
    },
    fees: {
      undergraduate: "AUD 20,000–45,000/year",
      postgraduate: "AUD 22,000–50,000/year",
      phd: "-",
      transport: "AUD 30 - 60/week",
      rent: "AUD 165– 440/week",
      food: "AUD 140 - 280/week",
      internet: "AUD 500 – 600/year",
      
    },
    programs: [
        {
            id:1,
            name: "Business and Management",
            description: "These programs are popular due to their versatility, preparing graduates for roles in finance, marketing, HR, and entrepreneurship."
        },
        {
            id:2,
            name: "Engineering",
            description: "With a focus on innovation and infrastructure, civil, mechanical, and electrical engineering are top choices."
        },
        {
            id:3,
            name: "Information Technology (IT)",
            description: "IT courses, including data science, cybersecurity, and software development, are sought after as the tech industry continues to grow."
        },
        {
            id:4,
            name: "Nursing and Health Sciences",
            description: "Australia's healthcare system makes these degrees highly regarded, offering strong employment prospects both domestically and internationally."
        },
        {
            id:5,
            name: "Medicine and Health Sciences",
            description: "Programs at institutions like London Business School and Warwick Business School are globally recognized."
        },
    ],
    schools: [
        {
            id:1,
            logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQH9eH1mN_6bEeZAtTz2CCssprBBENX9f5iOg&s",
            name: "The University of Sydney",
        },
        {
            id:2,
            logo: "https://ires.ubc.ca/files/2020/08/the-university-of-melbourne-vector-logo.jpg",
            name: "The University of Melbourne",
        },
        {
            id:3,
            logo: "https://rsaa.anu.edu.au/sites/prod.rsaa.sca-lws06.anu.edu.au/files/UNSW_logo.jpg",
            name: "The University of New South Wales (UNSW)",
        },
        {
            id:4,
            logo: "https://i1.wp.com/wald.anu.edu.au/wp-content/uploads/2018/07/cropped-Australian-National-University-Logo-1-3.png?fit=730%2C250",
            name: "Australian National University (ANU)",
        },
        {
            id:5,
            logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR2phhhwWN7lixuWESp07Y9lNiuZNPaV7uKjQ&s",
            name: "Monash University",
        },
        {
            id:6,
            logo: "https://images.squarespace-cdn.com/content/v1/5c6abbc83560c32e41568416/1563694784906-4DT7SOD5UG9AW8FN829E/University-of-Queensland-UQ-logo.png",
            name: "University of Queensland",
        },
        {
            id:7,
            logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcShHjzg51ZmkzkVKboJWZXIZ5qclZJhG84WGA&s",
            name: "University of Technology Sydney (UTS)",
        },
        {
            id:8,
            logo: "https://w7.pngwing.com/pngs/540/781/png-transparent-university-of-wollongong-in-dubai-student-bachelor-s-degree-student.png",
            name: "University of Wollongong",
        },
        // {
        //     id:9,
        //     logo: "https://storage-prtl-co.imgix.net/endor/organisations/217/logos/1724312092_uclan_primary_logo_digital-1.png",
        //     name: "Curtin University",
        // },
        {
            id:10,
            logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTvzJUkaqTD78pAujjYzmfMwtoXT6Zx_NPx9Q&s",
            name: "University of Tasmania",
        },
       
        
    ],
    admissions: [
        {
            id:1,
            name: "Undergraduate Programs",
            description: "Completion of secondary education equivalent to Australia's Year 12 certificate, with specific prerequisites depending on the program."
        },
        {
            id:2,
            name: "Postgraduate Programs",
            description: "A recognized undergraduate degree in a related field; some programs may require relevant work experience."
        },
        {
            id:3,
            name: "English Language Proficiency",
            description: "IELTS: Overall score of 6.5, with no band less than 6.0. •	TOEFL: Overall score of 79, with specific minimum section scores. •	PTE Academic: Overall score of 58-64, with no section score less than 50."
        },
        {
            id:4,
            name: "Additional Documents",
            description: "•	Passport Copy for identification and visa purposes. •	Academic Transcripts from previous institutions. •	CV for programs requiring work experience. •	Statement of Purpose outlining motivations and goals. •	Letters of Recommendation for postgraduate programs."
        },
        
    ],
    regions: [
      {
          school1: "The University of Sydney",
          school2: "The University of Melbourne",
        school3: "The University of New South Wales (UNSW)",
      },
    ],
    whyStudy1: {
        title: "Post-Study Work Opportunities",
        body: "Generous post-study work visas allow international graduates to gain work experience and apply for permanent residency (Amber, 2024)"
    },
    whyStudy2: {
        title: "High-Quality Education",
        body: "Universities such as the University of Melbourne and Australian National University are globally ranked and recognized for research excellence (QS, 2024; Times Higher Education, 2024)"
    },
    whyStudy3: {
        title: "World-Leading Research Fields",
        body: "Australia excels in fields such as environmental science, medical technology, and renewable energy (Times Higher Education, 2024)"
    },
    whyStudy4: {
        title: "Safe and Welcoming Environment",
        body: "Known for its safety and inclusivity, Australia is a favorite among students from all over the world (QS, 2024; Study Australia, 2024)​"
    },
  },
  ireland: {
    name: "Ireland",
    description:
      "A vibrant and friendly country renowned for its top-notch education, rich cultural heritage, and warm hospitality.",
    schDescription: "Ireland boasts a range of top-tier universities known for their research output, academic reputation, and excellent international student support. Key institutions includes:",
    flag: "🇮🇪",
    thumbnail: irelandBanner,
    whyStudy:"Ireland’s world-class education system and thriving economy make it an excellent choice for students eager to expand their academic knowledge and professional horizons.",
    topSchools: [
      "https://hea.ie/assets/uploads/2017/04/TCD-1000x500.jpg",
      "https://images.squarespace-cdn.com/content/v1/54998eb5e4b0a4688eb1c092/1723398615850-EQR8FIYFIMNZI0CNGSOY/ALC_Copy+of+2361_037.jpg?format=2500w",
      "https://images.shiksha.com/mediadata/images/1664883749phpmwMWmw_g.jpg",
    ],
    overview: {
      students: "40,400 ",
      colleges: "33 ",
      capital: "Dublin",
      language: "English",
      currency: "Euro",
      dailingCode: "+353",
      gdp: "$ 545.6 billion",
      population: "5.262 Million",
    },
    fees: {
      undergraduate: "€9,000–20,000/year",
      postgraduate: "€9,150–18,000/year",
      phd: "-",
      transport: "€100–150/month",
      rent: "€500–1,500/month",
      food: "€250-€400/month",
      internet: "€500–1,000/year",
      
    },
    programs: [
        {
            id:1,
            name: "Business Analytics",
            description: "With businesses increasingly relying on data-driven decisions, this field is essential. Ireland's business environment, along with the presence of multinational companies, offers great opportunities for studying business analytics."
        },
        {
            id:2,
            name: "Investment Banking and Finance",
            description: "Dublin is a hub for investment banks and asset management companies, creating high demand for professionals in finance, particularly in risk and compliance roles."
        },
        {
            id:3,
            name: "Big Data / Data Science",
            description: "With the exponential growth of data, Ireland's IT industry is booming, making it a top destination for data science and big data analytics programs."
        },
        {
            id:4,
            name: "Pharmaceutical Sciences",
            description: "Ireland hosts many global pharmaceutical companies, leading to a growing demand for professionals trained in this field."
        },
        {
            id:5,
            name: "Creative Media and Digital Marketing",
            description: "The rise of digital platforms has led to increased demand for media and marketing professionals, with Ireland offering specialized programs for this dynamic sector."
        },
    ],
    schools: [
        {
            id:1,
            logo: "https://media.licdn.com/dms/image/v2/C4D12AQFH8NUpVMcx2A/article-cover_image-shrink_600_2000/article-cover_image-shrink_600_2000/0/1643456247614?e=2147483647&v=beta&t=M4OvqJ-biJhvYGtcWq9dZceUmK9rmdy9lZH12BN3geQ",
            name: "Trinity College Dublin (TCD)",
        },
        {
            id:2,
            logo: "https://educationireland.in/wp-content/uploads/2024/10/2.webp",
            name: "University College Dublin (UCD)",
        },
        {
            id:3,
            logo: "https://upload.wikimedia.org/wikipedia/en/7/79/University_of_Galway_logo_2022.png",
            name: "National University of Ireland, Galway (NUI Galway)",
        },
        {
            id:4,
            logo: "https://www.liblogo.com/img-logo/max/uc6395u094-ucc-logo-ucc-logo-university-college-cork-eps-company-logo.png",
            name: "University College Cork (UCC)",
        },
        {
            id:5,
            logo: "https://ehef-japan.org/en/wp-content/uploads/sites/2/2024/04/International_Digital_Official_Navy.png",
            name: "Dublin City University (DCU)",
        },
        {
            id:6,
            logo: "https://cyberireland.ie/wp-content/uploads/2023/11/NCI_Logo_colour_transparent_HIres-3.png",
            name: "National College of Ireland (NCI)",
        },
        {
            id:7,
            logo: "https://www.entrepreneurial-universities.org/img/logos/Slide63.JPG",
            name: "Dublin Institute of Technology (DIT)",
        },
        {
            id:8,
            logo: "https://www.ul.ie/themes/custom/ul/logo.svg",
            name: "University of Limerick (UL)",
        },
        {
            id:9,
            logo: "https://www.vei.global/wp-content/uploads/2021/06/ait-logo.jpg",
            name: "Athlone Institute of Technology",
        },
        {
            id:10,
            logo: "https://ehef.id/storage/app/uploads/public/5fa/816/e1e/5fa816e1e879a882506713.jpg",
            name: "Institute of Technology Carlow",
        },
        {
            id:11,
            logo: "https://www.wtu-n.net/wp-content/uploads/2019/03/WIT-300x174.jpg",
            name: "Waterford Institute of Technology",
        },
        {
            id:12,
            logo: "https://oliveconsulting.in/wp-content/uploads/2020/09/5da5e4dd5900f.png",
            name: "Limerick Institute of Technology",
        },
       
        
    ],
    admissions: [
        {
            id:1,
            name: "Undergraduate Programs",
            description: "Completion of secondary education equivalent to the Irish Leaving Certificate, with at least 60% in Standard XII. Specific course prerequisites may apply."
        },
        {
            id:2,
            name: "Postgraduate Programs",
            description: "A recognized undergraduate degree, typically requiring a 2.1 honors degree (60%) or its equivalent."
        },
        {
            id:3,
            name: "English Language Proficiency",
            description: "•	IELTS: Overall score of 6.5, with no band below 6.0. •	TOEFL: Overall score of 90, with minimum scores in each section. •	PTE Academic: Overall score of 63, with no section below 59."
        },
        {
            id:4,
            name: "Additional Documents",
            description: "•	Passport Copy for visa and identification purposes. •	Academic Transcripts from previous institutions. •	CV for programs that require work experience. •	Statement of Purpose outlining motivations and goals. •	Letters of Recommendation, typically for postgraduate programs."
        },
        
    ],
    regions: [
      {
        school1: "Trinity College Dublin (TCD)",
        school2: "University College Dublin (UCD)",
        school3: "National University of Ireland, Galway (NUI Galway)",
      },
    ],
    whyStudy1: {
        title: "Post-Graduation Opportunities",
        body: "Ireland provides a two-year post-study work visa, enabling graduates to gain experience in a thriving economy (Amber, 2024)​"
    },
    whyStudy2: {
        title: "Globally Recognized Universities",
        body: "Ireland boasts world-class institutions like Trinity College Dublin and University College Dublin, with strong emphasis on research and academic rigor (Amber, 2024)​"
    },
    whyStudy3: {
        title: "Tech and Innovation Hub",
        body: "As home to major tech giants’ European headquarters, Ireland offers unique opportunities in IT, data science, and business analytics (University World News, 2024)​"
    },
    whyStudy4: {
        title: "Rich Cultural and Natural Heritage",
        body: "Ireland offers students a chance to experience its vibrant culture, music, and stunning landscapes, adding to their overall experience (Times Higher Education, 2024)​ Study.eu EduRank"
    },
  },
  italy: {
    name: "Italy",
    description:
      "Known for its historic universities, and breathtaking landscapes, Italy combines high-quality education with a unique cultural experience.",
    schDescription: "Italy is known for its rich academic history and is home to some of the oldest and most prestigious universities in the world. These institutions are recognized for their high-quality education, research excellence, and cultural significance:",
    flag: "🇮🇹",
    thumbnail: italyBanner,
    whyStudy:"With its historic universities and vibrant culture, Italy provides a unique and enriching environment for students seeking higher education and career development.",
    topSchools: [
      "https://static.bolognawelcome.com/immagini/45/93/3e/af/20200228141157.jpg",
      "https://www.iese-exchange.nl/index2.php?option=com_resource&task=show_picture&no_html=1&size=&picture=4610",
      "https://www.uis.no/sites/default/files/styles/large/public/2022-11/shutterstock_264609836.jpg?itok=Xqr_uUFQ",
    ],
    overview: {
      students: "96,083 ",
      colleges: "200",
      capital: "Rome",
      language: "Italian",
      currency: "Euro",
      dailingCode: "+39",
      gdp: "$ 2.255 trillion",
      population: "58.76 Million",
    },
    fees: {
      undergraduate: "€500 - €4,000/year",
      postgraduate: "€500 - €4,000/year",
      phd: "-",
      transport: "€25 - €45/month",
      rent: "€300 - €700/month",
      food: " €250 - €350/month",
      internet: "€25 - €45/month",
      
    },
    programs: [
        {
            id:1,
            name: "Economics and Management",
            description: "Universities like the University of Turin offer solid programs in economics and management, preparing students for careers across various sectors."
        },
        {
            id:2,
            name: "Engineering and Technology",
            description: "The University of Padua provides cutting-edge programs in engineering and technology, attracting students interested in innovation and research."
        },
        {
            id:3,
            name: "Humanities and Arts",
            description: "Italy's rich cultural heritage makes it an ideal destination for studying humanities and arts, with institutions like the University of Bologna offering comprehensive programs."
        },
    ],
    schools: [
        {
            id:1,
            logo: "https://upload.wikimedia.org/wikipedia/commons/d/d0/Seal_of_the_University_of_Bologna.svg",
            name: "University of Bologna",
        },
        {
            id:2,
            logo: "https://s3.cbk.cloud.syseleven.net/elg-public/7e04c06ffa464b40a91d591ef4e7a9dc_u105_a50038_6612731bb89148d483d536bd8624e3de~mv2.webp",
            name: "Sapienza University of Rome",
        },
        {
            id:3,
            logo: "https://conflictoflaws.de/News/2018/11/Logo_Universit%C3%A0_degli_Studi_di_Milano.svg_.png",
            name: "University of Milan",
        },
        {
            id:4,
            logo: "https://admin.seedglobaleducation.com/assets/img/school_logos/673da0cc9a108_Bocconi_Updated_logo.png",
            name: "Bocconi University",
        },
        {
            id:5,
            logo: "https://qubip.eu/wp-content/uploads/2023/09/Logo_PoliTo_dal_2021_blu.png",
            name: "Politecnico di Torino",
        },
        {
            id:6,
            logo: "https://upload.wikimedia.org/wikipedia/en/5/52/University_of_Florence.svg",
            name: "University of Florence",
        },
        {
            id:7,
            logo: "https://i.namu.wiki/i/FUuo5vjUse-V7539BVu1bBvOijISV3ZX1Jl32uG_RB_C5qEG2baF_i5OnrvdIA8x-vrKnHKR2zeCa3Ho8I4iZw.webp",
            name: "University of Trento",
        },
        {
            id:8,
            logo: "https://i.pinimg.com/originals/99/84/a1/9984a18946ed2ab19f0371f958a39853.png",
            name: "Ca' Foscari University of Venice",
        },
        {
            id:9,
            logo: "https://upload.wikimedia.org/wikipedia/en/thumb/c/c1/University_of_Siena.png/220px-University_of_Siena.png",
            name: "University of Siena",
        },
       
        
    ],
    admissions: [
        {
            id:1,
            name: "Undergraduate Programs",
            description: "Completion of secondary education equivalent to the Italian high school diploma. Applicants must have 12 years of schooling and be eligible for higher education in their home country."
        },
        {
            id:2,
            name: "Postgraduate Programs",
            description: "A relevant bachelor's degree is required for admission to master's programs. Some universities, like Università Cattolica del Sacro Cuore, require a minimum GPA of 75% or above."
        },
        {
            id:3,
            name: "Language Proficiency",
            description: "•	Italian-Taught Programs: Proof of Italian language proficiency is typically required, often through language tests or preparatory courses. •	English-Taught Programs: Proficiency in English must be demonstrated through tests like IELTS or TOEFL."
        },
        {
            id:4,
            name: "Additional Documentation",
            description: "•	Passport or EU Identity Card. •	Academic Transcripts from previous studies. •	Completed Application Form. •	Letters of Recommendation for some programs. •	Personal Statement outlining motivations and goals."
        },
        
    ],
    regions: [
      {
        school1: "University of Bologna",
        school2: "Sapienza University of Rome",
        school3: "University of Milan",
      },
    ],
    whyStudy1: {
        title: "Post-Graduation Opportunities",
        body: " Italy provides opportunities to stay and work after graduation, particularly in industries such as fashion, design, engineering, and tourism. Sources: Study in Italy, QS Rankings​"
    },
    whyStudy2: {
        title: "World-Class Education",
        body: "Italy is home to some of the oldest and most prestigious universities in the world, offering high-quality education across various disciplines.​"
    },
    whyStudy3: {
        title: "Rich Cultural Experience",
        body: "Studying in Italy offers students the chance to immerse themselves in one of the world’s most culturally rich countries, known for its art, architecture, and history.​"
    },
    whyStudy4: {
        title: "Diverse and Inclusive Environment",
        body: "With students from all over the world, Italy offers a welcoming and inclusive environment that promotes cultural exchange and global networking. Sources: Times Higher Education, Amberstudent"
    },
  },
  dubai: {
    name: "Dubai",
    description:
      "A dynamic global city known for its world-class education, cutting-edge infrastructure, and vibrant multicultural environment.",
    schDescription: "Dubai is home to several prestigious universities that attract students from all over the world. Known for their modern campuses, cutting-edge research, and strong ties to global industries, these institutions provide an excellent academic environment",
    flag: "🇦🇪",
    thumbnail: dubaiBanner,
    whyStudy:"Dubai’s rapidly growing educational landscape and global business connections make it a compelling destination for students looking to enhance their academic and career journeys.",
    topSchools: [
        "https://ud.ac.ae/wp-content/uploads/2021/10/05-3-1.jpg",
      "https://www.aud.edu/media/wp2lyree/school-departments-aud_fj17393.jpg",
      "https://www.hw.ac.uk/image-library/news-articles/2021.xe34e3e50.jpg?h=960&w=1920&fit=crop-top&q=90&f=webp",
    ],
    overview: {
      students: "34,893",
      colleges: "65",
      capital: "Dubai",
      language: "Arabic",
      currency: "AED",
      dailingCode: "+971",
      gdp: "$ 116.779 billion",
      population: "3.638 Million",
    },
    fees: {
      undergraduate: "AED 37,500 - AED 70,000/year",
      postgraduate: "AED 55,000 - AED 75,000/year",
      phd: "-",
      transport: "AED 300 to AED 500/month",
      rent: "AED 3,500 - AED 7,000/month",
      food: "AED 2,000 - AED 3,000/month",
      internet: "AED 1,500 - AED 2,500/month",
      
    },
    programs: [
        {
            id:1,
            name: "Business Administration and Management",
            description: "Programs in business administration and management are highly sought after, with institutions like the University of Wollongong in Dubai offering comprehensive courses."
        },
        {
            id:2,
            name: "Engineering and Technology",
            description: "Engineering disciplines such as civil, mechanical, and electrical engineering are popular. Heriot-Watt University Dubai offers specialized engineering programs."
        },
        {
            id:3,
            name: "Computer Science and Information Technology",
            description: "As demand for IT professionals grows, programs in computer science and IT are in high demand. The University of Birmingham Dubai Campus offers these courses."
        },
    ],
    schools: [
        {
            id:1,
            logo: "https://d30mzt1bxg5llt.cloudfront.net/public/uploads/images/_signatoryLogo/UD-logos-02_2023-10-09-143834_fdrz.png",
            name: "University of Dubai (UD)",
        },
        {
            id:2,
            logo: "https://studypedia.com/wp-content/uploads/2022/02/audlogo2430_mediumThumb.png",
            name: "American University in Dubai (AUD)",
        },
        {
            id:3,
            logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/03/Heriot-Watt_University_logo.svg/800px-Heriot-Watt_University_logo.svg.png",
            name: "Heriot-Watt University Dubai",
        },
        {
            id:4,
            logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQGdKMoAu3sXeT0brYUMzWlHFMl8PdAoius_A&s",
            name: "Dubai Medical College (DMC)",
        },
        {
            id:5,
            logo: "https://keystoneacademic-res.cloudinary.com/image/upload/f_auto/q_auto/g_auto/w_auto/dpr_2.0/element/14/144149_logo-alghurair2x.png",
            name: "Al Ghurair University (AGU)",
        },
        {
            id:6,
            logo: "https://www.prototypesforhumanity.com/wp-content/uploads/2021/11/dubai-png.png",
            name: "Middlesex University Dubai",
        },
        {
            id:7,
            logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQbMgRBldLaFu0CaEXjl5mRIucqBRy_VobGIA&s",
            name: "Canadian University Dubai (CUD)",
        },
        {
            id:8,
            logo: "https://www.cdnlogo.com/logos/r/36/rit-dubai.svg",
            name: "Rochester Institute of Technology (RIT) Dubai ",
        },
        {
            id:9,
            logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQwWfYrE9k3mBb_NPsjUmjq3_KyThgZQrthUg&s",
            name: "Amity University Dubai",
        },
       
       
        
    ],
    admissions: [
        {
            id:1,
            name: "Undergraduate Programs",
            description: "Completion of secondary education equivalent to the UAE high school certificate. For example, Heriot-Watt University Dubai requires a minimum of 70% in the high school diploma and specific scores in standardized tests like SAT or ACT."
        },
        {
            id:2,
            name: "Postgraduate Programs",
            description: "A relevant bachelor's degree or equivalent is needed for master's programs. Specific requirements may vary."
        },
        {
            id:3,
            name: "Language Proficiency",
            description: "Proficiency in English is typically required for English-taught programs, demonstrated through tests like IELTS or TOEFL. Minimum score requirements vary by institution."
        },
        {
            id:4,
            name: "Additional Documentation",
            description: "•	Passport Copy with necessary validity. •	Recent Passport-Sized Photographs. •	Proof of Financial Means (bank statements or financial documents).	•	Health Insurance (valid coverage in the UAE). •	Completed Visa Application (facilitated by the university)."
        },
        
    ],
    regions: [
      {
          school1: "University of Dubai",
          school2: "American University in Dubai",
        school3: "Heriot-Watt University Dubai",
      },
    ],
    whyStudy1: {
        title: "Post-Graduation Opportunities",
        body: "Dubai provides ample job opportunities in various sectors. Students can stay and work in Dubai after graduation, with many universities offering strong career placement services."
    },
    whyStudy2: {
        title: "Globally Recognized Universities",
        body: "Dubai is home to branch campuses of world-renowned universities like Heriot-Watt, University of Wollongong, and Middlesex University, offering globally accredited degrees."
    },
    whyStudy3: {
        title: "Innovation and Business Hub",
        body: "Dubai’s strategic position as a global business hub offers students unparalleled opportunities to network and intern with top companies across industries, including finance, tech, and hospitality"
    },
    whyStudy4: {
        title: "Diverse and Inclusive Environment",
        body: "With students from over 180 nationalities, Dubai offers a culturally enriching experience. It is a safe, modern city with a blend of traditional culture and futuristic infrastructure.​"
    },
  },


};

export const getAllCountries = () => {
  return Object.keys(countriesDatabase).map((code) => ({
    code,
    ...countriesDatabase[code],
  }));
};
